import { SeoCrossLinks } from '../../components/SeoCrossLinks';
import { seoCrossLinksMock } from './mock';

export function SeoCrossLinksContainer() {
  const crossLinks = seoCrossLinksMock;

  return <SeoCrossLinks seoBlocks={crossLinks} />;
}
